import { Box, Divider, Typography } from '@mui/material'
import { ConversionTable } from './components/ConversionTable'

export default function SpendBasedConversionFactors({ year, conversionFactor, company }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Divider />
        <Typography variant='h5' component='h6' >
          {`${conversionFactor} for ${year}`}
        </Typography>
      </Box>
      <ConversionTable year={year} companyId={company.id} />
    </Box>
  )
}
